import * as types from './types';
import faq from '../queries/faq';

export const fetch = ({ commit }) => {
  faq.getList()
    .then((response) => {
      const { data } = response;
      const currentUserInfo = data.current_user_info;
      const faqCategories = currentUserInfo.faq_categories;

      commit(types.SET_FAQ_LIST, faqCategories);
    });
};

export const setActive = ({ commit }, question) => {
  commit(types.SET_ACTIVE_FAQ, question);
};



// WEBPACK FOOTER //
// ./src/screens/Faq/store/actions.js